import React from "react";

const logoStyle = {
  display: "block",
  "margin-left": "auto",
  "margin-right": "auto",
  width: "50%",
};

export const Logo = () => {
  return (
    <img src="/assets/images/logo.svg" alt="TrustedTechy" style={logoStyle}></img>
  );
};
